import { useState } from "react";
import Spinner from "../../sharedComponents/Spinner";
import { BsFillCheckCircleFill, BsXCircleFill } from "react-icons/bs";
import { applyDiscountCode } from "../../utils/ApiCalls";
import { toast } from "react-toastify";

const compareIgnoreCase = (str1, str2) => {
  return str1.trim().toLowerCase() === str2.trim().toLowerCase();
};

export default function DiscountInput({
  storeID,
  setDiscount,
  discountList,
  discount,
  theme,
}) {
  const [discountCode, setDiscountCode] = useState("");

  const handleDiscountCode = async (e) => {
    e.preventDefault();
    let response = discountList.find((x) =>
      compareIgnoreCase(x.discountCode, discountCode)
    );
    if (response) {
      toast(() => (
        <div className="align-items-center">
          <BsFillCheckCircleFill
            color="#0bc495"
            size={18}
            style={{ marginRight: 8, position: "relative", top: -2 }}
          />
          <span>Discount Applied Successfully</span>
        </div>
      ));
      setDiscount(response);
      return;
    }

    toast.error(() => (
      <div className="align-items-center">
        <BsXCircleFill
          color="red"
          size={18}
          style={{ marginRight: 8, position: "relative", top: -2 }}
        />
        <span>Discount code invalid</span>
      </div>
    ));
    setDiscount({});
  };

  return (
    <div className="card card--grey mt-2">
      <div className="card-body">
        <h2 className="fs-6">DISCOUNT/PROMO CODE</h2>
        <label className="text-uppercase d-none">Enter Coupon code:</label>
        <div className="input-group flex-nowrap">
          <input
            className="input-group__field"
            type="text"
            autoComplete="off"
            placeholder="Discount code"
            value={discountCode}
            onChange={(e) => setDiscountCode(e.target.value)}
            name="discount"
          />
          <span className="input-group__btn">
            <button
              disabled={!discountCode}
              className={`btn rounded-end text-nowrap ${theme}`}
              onClick={(e) => handleDiscountCode(e)}>
              Apply Code
            </button>
          </span>
        </div>
      </div>
    </div>
  );
}
